// extracted by mini-css-extract-plugin
export default {"waiting":"lsf-waiting"};